/** Vite base：根路径部署时为 ''，子路径部署时为 /service9 等 */
export const APP_BASE = (() => {
  const base = String(import.meta.env.BASE_URL ?? '/')
  if (base === '/' || base === '') return ''
  return base.replace(/\/$/, '')
})()

export function resolveApiBaseURL() {
  const v = import.meta.env.VITE_API_BASE_URL
  if (v === '' || v === '/') return APP_BASE
  if (v === '/api') {
    return import.meta.env.PROD ? APP_BASE : v
  }
  if (v) return String(v).replace(/\/$/, '')
  return APP_BASE
}

/** 发布网关 v2 相对路径（配合 axios baseURL，勿再拼 APP_BASE） */
export const PUBLISH_V2 = '/api/publish/v2'

/** 浏览器直连 URL（img src 等，需含 APP_BASE） */
export function publishV2PublicUrl(path = '') {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${APP_BASE}${PUBLISH_V2}${p}`
}

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${APP_BASE}${p}`
}

export const DEFAULT_VNC_WS_PATH = `${APP_BASE}/api/vnc/ws`
export const DEFAULT_VNC_VIEWER_PATH = `${APP_BASE}/vnc-viewer.html`

export function resolveWsBaseURL() {
  const httpBase = resolveApiBaseURL()
  if (/^https?:\/\//i.test(httpBase)) {
    return httpBase.replace(/^http/i, 'ws')
  }
  if (typeof window !== 'undefined') {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws'
    const cleaned = String(httpBase || '').replace(/^\/+|\/+$/g, '')
    return `${proto}://${window.location.host}${cleaned ? '/' + cleaned : ''}`
  }
  return ''
}

export function wsUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${resolveWsBaseURL()}${p}`
}
